import { AxiosError, AxiosRequestConfig } from 'axios'
import { useMutator as useOrvalMutator } from '@dhl/receiver-axios'

export const baseUrl = '/api'

export const useMutator = <T>(): ((config: AxiosRequestConfig) => Promise<T>) => useOrvalMutator(baseUrl)

// Axios errors will return data in a different way our generated client with TError is expecting,
// so we are adding it here so our generated client will know
// For example when we throw a 400 with a key we can get it like `mutation.error?.response?.data?.key`
// same to know its status etc its now correctly typed since we are using Axios
export type ErrorType<Error> = AxiosError<Error>
